export default __webpack_public_path__ + "static/media/08.28396265.jpg";